import { useEffect } from 'react';
import loglevel from 'loglevel';
import useStatusNotifications from 'hooks/useStatusNotifications';

const AppInitializer = () => {
  // ===== Global app bootstrap side effects =====

  const status = useStatusNotifications();

  useEffect(() => {
    // Document title
    document.title = CONFIG.app.document.title;

    // Log level
    loglevel.setLevel(CONFIG.app.log.level);
  }, []);

  return null;
};

export default AppInitializer;
